import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/betprofessor/images/logo/2x.png';

export default function Index() {
  return <Image src={logo} maxW="48" ml="2" />;
}
